import type { Maybe } from '@adornis/base/utilTypes.js';
import { Field } from '@adornis/baseql/decorators.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class MicrosoftData extends AdornisEntity {
  static override _class = 'MicrosoftData';

  @Field(type => String)
  microsoftID: Maybe<string>;

  @Field(type => Date)
  createdInEntra: Maybe<Date>;
}
